export default class VacanciesFilters {
    constructor(filterBlock) {
        this.filterBlock = filterBlock;
        this.body = document.body;
        this.workTypeSection = document.querySelector('.work-types');
        if (this.workTypeSection) {
            this.workTypeToggleBUttons = this.workTypeSection.querySelectorAll('[data-show-vacancies]');
        }
        this.selectedFilters = {};
        if (this.filterBlock) {
            this.filterToggleButton = this.filterBlock.querySelectorAll('[data-filter-toggle]');
            this.filtersContainer = this.filterBlock.querySelector('.filters-container');
            this.filters = this.filterBlock.querySelectorAll('[data-filter-value] input');
            this.vacancies = document.querySelectorAll('[data-vacancy]');
            this.clearFiltersButton = this.filterBlock.querySelector('[data-clear-filters]');
            this.addEventListeners();
        }
    }
    addEventListeners() {
        this.filterToggleButton.forEach(button => {
            button.addEventListener("click", () => {
                this.filtersContainer.classList.toggle('show');
                this.body.classList.toggle('no-scroll');
                this.body.parentElement.classList.toggle('no-scroll');
            });
        });
        this.filters.forEach(filter => {
            filter.addEventListener("change", () => {
                const filterContainer = filter.parentElement.parentElement;
                const filterType = filterContainer.parentElement.getAttribute('data-filter-type');
                const targetIds = filterContainer.getAttribute('data-filter-value').split(',');
                this.setFilters(filterType, targetIds);
            });
        });
        this.clearFiltersButton.addEventListener("click", (event) => {
            event.preventDefault();
            this.setFilters('clear', []);
        });
        if (this.workTypeToggleBUttons) {
            this.workTypeToggleBUttons.forEach(button => {
                button.addEventListener("click", () => {
                    const type = button.getAttribute('data-type');
                    const value = button.getAttribute('data-value');
                    const filter = this.filtersContainer.querySelector(`[data-filter-type="${type}"]`);
                    const filterContainer = filter.querySelector(`[data-filter-name="${value}"]`);
                    const filterCheckbox = filterContainer.querySelector('input');
                    filterCheckbox.checked = !filterCheckbox.checked;
                    const targetIds = filterContainer.getAttribute('data-filter-value').split(',');
                    window.scrollTo({
                        top: this.filterBlock.offsetTop - 200,
                        behavior: 'smooth'
                    });
                    this.setFilters(type, targetIds);
                });
            });
        }
    }
    setFilters(filterType, filterValues) {
        if (filterType === 'clear') {
            this.selectedFilters = {};
            this.filterVacancies();
            this.availableFilters();
            // if this.selectedFilters is empty, remove hidden from clearFiltersButton
            if (Object.keys(this.selectedFilters).length === 0) {
                this.clearFiltersButton.parentElement.classList.add('hidden');
            }
            else {
                this.clearFiltersButton.parentElement.classList.remove('hidden');
            }
            return;
        }
        if (this.selectedFilters.hasOwnProperty(filterType)) {
            // Check if appliedFilter already exist such filter type
            const filterArray = this.selectedFilters[filterType];
            filterValues.forEach((filterValue) => {
                const index = filterArray.indexOf(filterValue);
                if (index === -1) {
                    // If filter value doesn't exist, add it to the filterArray
                    filterArray.push(filterValue);
                }
                else {
                    // If filterValue already exists, remove it from the filterArray
                    filterArray.splice(index, 1);
                    // If the filterArray is empty after removal, delete the filterType
                    if (filterArray.length === 0) {
                        delete this.selectedFilters[filterType];
                    }
                }
            });
        }
        else if (!this.selectedFilters.hasOwnProperty(filterType)) {
            // If filterType doesn't exist, create a new entry with an array containing filterValue
            //this.selectedFilters[filterType] = [parseInt(filterValue.toString())];
            this.selectedFilters[filterType] = filterValues;
        }
        // if this.selectedFilters is empty, remove hidden from clearFiltersButton
        if (Object.keys(this.selectedFilters).length === 0) {
            this.clearFiltersButton.parentElement.classList.add('hidden');
        }
        else {
            this.clearFiltersButton.parentElement.classList.remove('hidden');
        }
        this.filterVacancies();
        this.availableFilters();
    }
    filterVacancies() {
        // Get arrays of selected filter values
        const selectedFilterArrays = Object.values(this.selectedFilters);
        let filterValues = [];
        if (selectedFilterArrays.length > 0) {
            // Find the intersection of all filter arrays
            filterValues = selectedFilterArrays.reduce((acc, current) => {
                return acc.filter(value => current.includes(value));
            });
        }
        this.vacancies.forEach(vacancy => {
            const vacancyId = vacancy.getAttribute('data-vacancy');
            // If no filters are selected, show all vacancies
            if (filterValues.length === 0) {
                vacancy.classList.remove('hidden');
                return;
            }
            // Show vacancy if its ID is in the filtered values, otherwise hide it
            if (filterValues.includes(vacancyId)) {
                vacancy.classList.remove('hidden');
            }
            else {
                vacancy.classList.add('hidden');
            }
        });
    }
    availableFilters() {
        const filterValues = [...new Set(Object.values(this.selectedFilters).flat())];
        this.filters.forEach(filter => {
            const filterContainer = filter.parentElement.parentElement;
            const targetIds = filterContainer.getAttribute('data-filter-value').split(',');
            // if filterValues include any of the targetIds, disable the filter
            if (filterValues.some(value => targetIds.includes(value))) {
                filterContainer.classList.remove('inactive');
            }
            else {
                // uncheck input
                filter.checked = false;
                filterContainer.classList.add('inactive');
            }
            if (filterValues.length === 0) {
                filterContainer.classList.remove('inactive');
            }
        });
    }
}
const filterBlock = document.querySelectorAll('[data-filters]');
filterBlock.forEach((sliderBlock) => new VacanciesFilters(sliderBlock));
